(ns teamoesterreich.admin-mode.data.warning
  (:require [teamoesterreich.ajax :as ajax]
            [goog.json :as json]
            [clojure.walk]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.util.log :as log]))



(defn date-to-restDate [d]
  (let [t (clojure.string/replace (str (.toISOString d)) #"\.|:|-" "")]
    (str (subs t 0 15) "." (subs t 15))))

(defn >new-warning [warntext finished-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/warning")
                   (ajax/serialize {:warningCap-active    true
                                    :warningCap-published false
                                    :warningCap-level     "1"
                                    :warningCap-type-abbr     "ork"
                                    :warningCap-date      (date-to-restDate (js/Date.))
                                    :warningCap-warntext  warntext})
                   (fn [data status]
                     (when (= status 200)
                       (finished-fn data)))))

(defn >warning-edit [warning-uuid warning finished-fn]
  (ajax/auth-put> (backend/get-auth) (str backend/BASE_URL "/warning/" warning-uuid)
                  (ajax/serialize (merge warning
                                         {:warning-uuid warning-uuid}))
                  finished-fn))

(defn <get-warning-list [done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/warning/actual")
                  (fn [r-list status]
                    (when (= status 200)

                      ;(log/debug "get-warning ----------- done" r-list status (json/parse r-list))
                      (done-fn
                        (into {} (map (fn [e]
                                        ;(log/debug "get-warning " (clj->js e))
                                        (let [d (clojure.walk/keywordize-keys e)
                                              d (assoc d :_warningCap-typeName (get-in d [:warningCap-type :warningType-name])
                                                         :_warningCap-typeAbbr (get-in d [:warningCap-type :warningType-abbr]))]
                                          ;(log/debug "get-warning " (clj->js d))
                                          [(:warningCap-uuid d) d])
                                        ) (js->clj (json/parse r-list))))
                        )))))

(defn <get-warning [blockUuid done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/warning/" blockUuid)
                  (fn [r-list status]
                    ;(log/debug "get-blog done" r-list status)
                    (when (= status 200)
                      (done-fn
                        (into {} (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))
                        )))))
